/** Which sidebar tool a `?ref=<id>` in the URL opens: comments open Chat, the entity's notes open My Notes */
export type RefTool = 'Chat' | 'My Notes'

export const resolveRefTool = ({
  ref,
  commentIds,
  noteIds,
}: {
  ref: string | undefined
  commentIds: readonly string[]
  noteIds: readonly string[]
}): RefTool | null => {
  if (!ref) {
    return null
  }
  if (commentIds.includes(ref)) {
    return 'Chat'
  }
  return noteIds.includes(ref) ? 'My Notes' : null
}
